module.exports = __webpack_public_path__ + "img/graphic-11.0d8a5055.webp";